import { render, staticRenderFns } from "./LearningStudent.vue?vue&type=template&id=4e0304bf&scoped=true&"
import script from "./LearningStudent.vue?vue&type=script&lang=js&"
export * from "./LearningStudent.vue?vue&type=script&lang=js&"
import style0 from "./LearningStudent.vue?vue&type=style&index=0&id=4e0304bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0304bf",
  null
  
)

export default component.exports